import React from "react";
import { useIntl } from "react-intl";

import { queries } from "lib/build/dashboards/basic-health/queries";
import { Status } from "lib/build/forms/basic-health/patientCondition";

import {
	longStatusMessages,
	shortStatusMessages
} from "src/modules/basic-health/messages";
import { StatusChart as StatusChartShared } from "src/modules/shared/stats";

export const StatusChart: React.FunctionComponent = () => {
	const { formatMessage } = useIntl();

	const formatLongStatus = React.useCallback(
		(value: string) =>
			formatMessage(longStatusMessages[(value || Status.NEW) as Status]),
		[formatMessage]
	);

	const formatShortStatus = React.useCallback(
		(value: string) =>
			formatMessage(shortStatusMessages[(value || Status.NEW) as Status]),
		[formatMessage]
	);

	return (
		<StatusChartShared
			statusQuery={queries.patientStatus}
			formatLongStatus={formatLongStatus}
			formatShortStatus={formatShortStatus}
		/>
	);
};
